import { Store } from 'vuex';
import { mapResourceModules } from '@reststate/vuex';
import axios from 'axios';
import auth from '@/auth'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const httpClient = axios.create({
  baseURL: process.env.API_BASE_URL || 'https://api.projectsmaps.com' || 'http://0.0.0.0:5000',
  //baseURL: 'http://0.0.0.0:5000',
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Authorization': `JWT ${auth.getToken()}`,
  },
});

export default new Store({
  modules: {
    ...mapResourceModules({
      names: [
        'users',
        'projects',
        'project_assets'
      ],
      httpClient: httpClient,
    }),
  },
});